const article = {
  shareButton: "分享",
  exclusiveBadge: "独家爆料",
  authorPrefix: "作者",
  readCount: "阅读",
  commentCount: "评论",
  publishDate: "发布于",
  tags: "标签",
  commentSection: {
    label: "网友热评",
    title1: "吃瓜群众",
    title2: "怎么说",
  },
  relatedSection: {
    title1: "猜你喜欢",
    title2: "相关推荐",
    description: "看完这篇还不过瘾？这些热门爆料同样值得一读。",
  },
  structuredData: {
    articleType: "Article",
    publisherName: "51吃瓜网",
  },
};

export default article;